import { combineReducers } from 'redux';
import zones from './zones';
import manips from './manips';
import dirty from './dirty';
import insectsRef from './insectsRef';
import otherPestsRef from './otherPestsRef';
import capturesRef from './capturesRef';
import zonesRef from './zonesRef';
import zoneTemplatesRef from './zoneTemplatesRef';
import productmanips from './productmanips';

export const manipsReducer = combineReducers({
  zones,
  manips,
  dirty,
  insectsRef,
  otherPestsRef,
  capturesRef,
  zonesRef,
  zoneTemplatesRef,
  productmanips,
});



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/reducers/index.js